import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, App as AntApp } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
dayjs.extend(quarterOfYear);
import { App } from './App';
import { limeTheme } from './theme';
import './styles.css';
import './mobile.css';
dayjs.locale('zh-cn');
// 弹窗「确定」里 await form.validateFields() 校验不过会抛 { errorFields }，字段下已经标红提示，
// 这里吞掉这一种，免得控制台报未处理的 Promise；其他错误照常抛出
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && typeof e.reason === 'object' && Array.isArray((e.reason as { errorFields?: unknown }).errorFields)) e.preventDefault();
});
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN} theme={limeTheme}>
      <AntApp><App /></AntApp>
    </ConfigProvider>
  </React.StrictMode>,
);
